/**
 * Formats elapsed seconds as "45s" / "3m 12s" / "1h 15m".
 *
 * Matches the prototype's fmtElapsed (design-reference/src/atoms.jsx).
 * Keep behavior identical so the dashboard tiles read the same.
 */
export function fmtElapsed(sec: number | null | undefined): string {
  if (sec == null) return "—";
  if (sec < 60) return `${sec}s`;
  const m = Math.floor(sec / 60);
  const s = sec % 60;
  if (m < 60) return `${m}m ${String(s).padStart(2, "0")}s`;
  const h = Math.floor(m / 60);
  return `${h}h ${String(m % 60).padStart(2, "0")}m`;
}

const DATE_TIME = new Intl.DateTimeFormat(undefined, {
  month: "short",
  day: "numeric",
  hour: "numeric",
  minute: "2-digit",
  second: "2-digit",
});

/** ISO timestamp in the viewer's locale and time zone. "—" when absent or invalid. */
export function fmtDateTime(iso: string | null | undefined): string {
  if (!iso) return "—";
  const ms = Date.parse(iso);
  return Number.isFinite(ms) ? DATE_TIME.format(ms) : "—";
}
